import React, { useState } from "react";
import {
  Collapse,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import { kebabCase } from "lodash";
import hexRgb from "hex-rgb";

const MobileNav = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const websiteProvided =
    props.page?.company_website &&
    props.page?.company_website !== " " &&
    props.page?.company_website !== "null" &&
    props.page?.company_website !== "undefined";

  return (
    <div className="mobile-nav-container">
      <Navbar color="light" light expand="lg">
        <div className="navbar-wrapper">
          <NavbarBrand
            href={websiteProvided ? props.page.company_website : "/"}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: props.page.primary_color,
              fontSize: "22px",
              fontWeight: "bold",
            }}
          >
            {props.page.logo ? (
              <img
                className="logo logo-resize"
                src={props.page.logo}
                alt={props.page.name}
              />
            ) : (
              props.page.name
            )}
          </NavbarBrand>
        </div>
        <div className="navbar-toggle">
          <NavbarToggler className="mobile-nav-button" onClick={toggle}>
            <span className="navbar-toggler-bar bar1" />
            <span className="navbar-toggler-bar bar2" />
            <span className="navbar-toggler-bar bar3" />
          </NavbarToggler>
        </div>
        <Collapse isOpen={isOpen} navbar className="text-right bg-white">
          <Nav className="mr-auto" navbar>
            {props.page.sections
              ?.filter((x) => x.name !== "company_hero")
              .sort((a, b) => {
                return a.position - b.position;
              })
              .map((item, index) => {
                return (
                  <NavItem key={`nav-${index}`}>
                    <NavLink
                      href={`#${kebabCase(item.display_name)}`}
                      style={{ color: props.page.primary_color }}
                    >
                      {item.display_name}
                    </NavLink>
                  </NavItem>
                );
              })}
          </Nav>
          <a
            href={`mailto:${props.page.founder_email}`}
            className="btn btn-custom"
            style={{
              backgroundColor: props.page.primary_color,
              boxShadow:
                "0 0 15px " +
                hexRgb(`${props.page.primary_color}66`, { format: "css" }),
            }}
          >
            Contact Us
          </a>
        </Collapse>
      </Navbar>
    </div>
  );
};

export default MobileNav;
